import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { INSGridConfig } from '@norfolk-southern/accessns-components';
import { ColDef } from 'ag-grid-community';

import { NSECRConstants } from '@ruby/configs/ecr.constants';
import { IECRRequest } from '@ruby/shared/models/ecr/ecr.interface';

@Component({
  selector: 'ng-ecr-requests',
  templateUrl: './ecr-requests.component.html',
  styleUrls: ['./ecr-requests.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ECRRequestsComponent {
  @Input() loading!: boolean;
  @Input() requests!: Array<IECRRequest>;
  columns: Array<ColDef> = NSECRConstants.requestsColumns;
  config: INSGridConfig = {
    hide: {
      title: true,
      customizedReporting: true,
      print: true,
      download: {
        pdf: true,
        csv: true
      }
    }
  };

  constructor() { }
}
